var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPistachios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "pistachios",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pistaches") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pistaches",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("text", {
    id: "pistcahes",
    xmlSpace: "preserve",
    x: 6,
    y: 97,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "pistcahes"), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(30.563744, 20.079677)",
    fill: "#161615"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9374641,28.121679 C22.3280869,31.5184558 17.0006661,33.4659121 12.3218009,33.4659121 C8.4326389,33.4659121 5.30495067,32.1154915 3.51418449,29.6626274 C-0.599366121,24.0275121 3.21379324,14.1666058 12.0148951,7.6806601 C15.8157493,4.880919 20.0385989,3.07890381 24.0587748,2.52259162 L21.6469588,6.25606456 C21.646235,6.25679177 21.6455111,6.25751897 21.6455111,6.25824618 L10.2994077,23.8195314 C10.1358211,24.0733261 10.145231,24.4020229 10.3232942,24.6456368 C10.5006336,24.8892506 10.8097109,24.9983314 11.0999685,24.9161572 L35.4533752,18.1291485 C33.7168966,21.815353 30.7375944,25.3212107 26.9374641,28.121679 Z M31.1451131,9.30232832 C32.583372,11.2716008 32.334373,14.4334902 30.4784617,18.0069779 L12.5534279,23.0021524 L22.6769751,7.33305588 C26.6269391,6.62839377 29.7075781,7.33305588 31.1451131,9.30232832 Z M37.2484844,16.535114 C37.0646305,16.3322237 36.7823351,16.2493223 36.5195832,16.3234972 L32.3322015,17.4899348 C33.9050935,13.8779052 33.9152272,10.6374776 32.3126579,8.44204424 C30.7100887,6.2473381 27.6294497,5.28451804 23.7279826,5.70557001 L26.094197,2.04409041 C26.2425831,1.81356627 26.2498214,1.51832085 26.1122929,1.28125186 C25.9740405,1.04418287 25.7170793,0.903105011 25.4420223,0.922012354 C20.719727,1.21653057 15.6478197,3.20107433 11.1585991,6.50840486 C1.71400846,13.4677613 -2.23885092,24.2405833 2.34736352,30.5229115 C4.41752976,33.3582857 7.95997507,34.9195958 12.3218009,34.920323 C12.3225247,34.920323 12.3225247,34.920323 12.3225247,34.920323 C17.302505,34.920323 22.9411746,32.8696036 27.7930363,29.2939342 C32.2822569,25.9866037 35.690069,21.7222707 37.3881844,17.2848629 C37.485902,17.0281594 37.4323383,16.7387316 37.2484844,16.535114 L37.2484844,16.535114 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1158061,13.2068292 C11.4661771,12.9737738 11.5403548,12.5276187 11.2831004,12.2111765 C11.0250568,11.8940215 10.5310651,11.8256016 10.1814832,12.058657 C9.9763109,12.1947842 5.13108911,15.4668254 3.45656784,22.0479688 C3.35871645,22.4321182 3.62386214,22.8141296 4.04841089,22.9025053 C4.10838432,22.9146214 4.16756862,22.920323 4.2259638,22.920323 C4.58580438,22.920323 4.9109235,22.6972455 4.99457065,22.3672618 C6.53257346,16.3242129 11.0700369,13.2374756 11.1158061,13.2068292",
    id: "Fill-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPistachios);
export default __webpack_public_path__ + "static/media/pistachios.a0e7e41036de903d07775727835c31bf.svg";
export { ForwardRef as ReactComponent };